<nav [attr.aria-label]="'common.breadcrumbs' | cxTranslate" tabindex="-1">
  <ol [attr.aria-label]="'common.breadcrumbs' | cxTranslate">
    <li
      *ngFor="
        let crumb of crumbs$ | async as crumbList;
        let i = index;
        let last = last
      "
    >
      <a
        [routerLink]="crumb.link"
        [innerHTML]="crumb.label"
        [attr.aria-label]="
          last
            ? ('common.breadcrumbsCurrentPage' | cxTranslate) +
              ' ' +
              crumb.label +
              (i + 1) +
              ('common.of' | cxTranslate) +
              crumbList.length
            : crumb.label +
              (i + 1) +
              ('common.of' | cxTranslate) +
              crumbList.length
        "
      ></a>
    </li>
  </ol>
</nav>

<!-- TODO: Remove feature flag next major release -->
<ng-container *cxFeature="'a11yPreventSRFocusOnHiddenElements'">
  <h1 [attr.aria-live]="(ariaLive$ | async) ? 'polite' : null">
    {{ title$ | async }}
  </h1>
</ng-container>
<ng-container *cxFeature="'!a11yPreventSRFocusOnHiddenElements'">
  <!-- Hidden page title for Screen Reader initialized after view to avoid old values -->
  <span class="cx-visually-hidden" aria-live="polite" aria-atomic="true">
    {{ lastestTitle$ | async }}
  </span>
  <h1>{{ title$ | async }}</h1>
</ng-container>
